<template>
  <!-- 新增 -->
  <el-dialog
    title="添加"
    :visible.sync="dialogForm.visible"
    width="1000px"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    v-dialogDrag
    @open="openDialog"
  >
    <el-row>
      <el-select
        v-model="search.attributeId"
        clearable
        filterable
        placeholder="属性名称"
        size="small"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in attrList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        filterable
        v-model="search.symbolValue"
        placeholder="请选择"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in symbolList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        v-model="search.keywords"
        clearable
        placeholder="请输入"
        size="small"
        class="w-200px mr-10px"
      >
      </el-input>
      <el-button type="primary" @click="searchTableData">搜索</el-button>
    </el-row>
    <el-table
      border
      :data="tableData"
      v-loading="tableLoading"
      :highlight-current-row="true"
      height="500px"
      ref="table"
      class="mt-20px"
      @selection-change="selectionChange"
      row-key="id"
    >
      <el-table-column
        v-if="tableHeader.length && dialogTitle !== '审批'"
        fixed
        :reserve-selection="true"
        type="selection"
        width="40"
      ></el-table-column>
      <el-table-column label="序号" width="60" v-if="tableHeader.length">
        <template slot-scope="scope">
          {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="(val, index) in tableHeader"
        :prop="`${val.tableName}.${val.columnName}`"
        show-overflow-tooltip
        :key="index"
        :label="val.name"
        min-width="150"
      >
        <template slot-scope="scope">
          <div class="truncate">
            {{ scope.row[`${val.tableName}.${val.columnName}`] }}
            <span v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]">{{
              val.unit
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tableHeader.length"
        label="数据修改内容"
        prop="update_json"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <div class="mt-20px">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <el-row slot="footer">
      <el-button type="primary" size="small" @click="saveData">确认</el-button>
      <el-button size="small" @click="closeDialog">{{ $t('cancel') }}</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import assetService from '@/services/assetService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'

export default {
  name: 'addAttributeData',
  props: ['dialogForm', 'dialogTitle'],
  data() {
    return {
      tableHeader: [],
      tableData: [],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      search: {
        attributeId: '',
        symbolValue: '',
        keywords: '',
      },
      attrList: [],
      selectList: [],
      symbolList: [],
    }
  },
  methods: {
    async openDialog() {
      this.search = this.$options.data().search
      await this.getAttrList()
      await this.getSymbolList()
      this.getDynamicTableHeader()
      this.searchTableData()
    },
    // 获取属性列表
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.dialogForm.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attrList = res.data
        if (this.attrList.length) {
          this.search.attributeId = this.attrList[0].id
        }
      }
    },
    // 获取操作符
    async getSymbolList() {
      const res = await assetService.getSearchOperator()
      if (res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          this.symbolList.push({
            label: item.text,
            value: item.value,
          })
        })
        if (this.symbolList.length) {
          this.search.symbolValue = this.symbolList[0].value
        }
      }
    },
    // 获取实体数据管理动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({
        classId: this.dialogForm.classId,
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      }
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await stdClassDataService.getDynamicTableData({
        classId: this.dialogForm.classId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        whereList: [],
        classAttributeId: this.search.attributeId,
        operator: this.search.symbolValue,
        keywords: this.search.keywords,
        showUpdateData: true,
        approveStatus: [0, 1],
        // isAddApproveData: true,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    closeDialog() {
      this.$refs.table.clearSelection()
      this.$emit('closeDialogForm')
    },
    saveData() {
      if (this.selectList.length === 0) {
        this.$message.warning('请选择要添加的数据！')
        return
      }
      this.$emit('updateData', this.selectList)
      this.closeDialog()
    },
    selectionChange(val) {
      this.selectList = val
    },
  },
}
</script>
